import React from 'react';
import { RequestStatus } from '../../shared/enums/request-status';
import { SortOrder } from '../../shared/enums/order';
import {
  DateRangeFilter,
  EnrichmentStatus,
  EnrichmentType,
} from './enums/csv-enrichment.enums';
import { EnrichmentJob, EnrichmentStats } from './types/csv-enrichment.types';
import EnrichmentHeader from './components/enrichment-header/enrichment-header';
import EnrichmentStatsComponent from './components/enrichment-stats/enrichment-stats';
import EnrichmentToolbar from './components/enrichment-toolbar/enrichment-toolbar';
import EnrichmentTable from './components/enrichment-table/enrichment-table';

export type CsvEnrichmentProps = {
  // Data
  jobs: EnrichmentJob[];
  jobsRequestStatus: RequestStatus;
  stats: EnrichmentStats;
  statsRequestStatus: RequestStatus;

  // Filters
  dateRange: DateRangeFilter;
  searchQuery: string;
  statusFilter: EnrichmentStatus | null;
  typeFilter: EnrichmentType | null;

  // Pagination
  page: number;
  pageSize: number;
  totalJobs: number;

  // Sort
  sortBy: string | null;
  sortOrder: SortOrder | null;

  // Handlers
  onDateRangeChange: (range: DateRangeFilter) => void;
  onSearchChange: (value: string) => void;
  onStatusFilterChange: (status: EnrichmentStatus | null) => void;
  onTypeFilterChange: (type: EnrichmentType | null) => void;
  onClearAllFilters: () => void;
  onPaginationChange: (payload: { page?: number; limit?: number }) => void;
  onSortChange: (sortBy: string, order: SortOrder) => void;
  onNewEnrichment: () => void;
  onAddToProspects: (id: string) => void;
  onAddToSequence: (id: string) => void;
  onExport: (id: string) => void;
  onFailedReport: (id: string) => void;
  onDelete: (id: string) => void;
  onCancel: (id: string) => void;
  onRetry: () => void;
  onViewJob?: (id: string) => void;
};

const CsvEnrichment: React.FC<CsvEnrichmentProps> = ({
  jobs,
  jobsRequestStatus,
  stats,
  statsRequestStatus,
  dateRange,
  searchQuery,
  statusFilter,
  typeFilter,
  page,
  pageSize,
  totalJobs,
  sortBy,
  sortOrder,
  onDateRangeChange,
  onSearchChange,
  onStatusFilterChange,
  onTypeFilterChange,
  onClearAllFilters,
  onPaginationChange,
  onSortChange,
  onNewEnrichment,
  onAddToProspects,
  onAddToSequence,
  onExport,
  onFailedReport,
  onDelete,
  onCancel,
  onRetry,
  onViewJob,
}) => {
  const hasActiveFilters =
    (searchQuery && searchQuery.trim().length > 0) ||
    statusFilter !== null ||
    typeFilter !== null;

  return (
    <div className="bs-csv-enrichment">
    {/* <EnrichmentHeader
      dateRange={dateRange}
      onDateRangeChange={onDateRangeChange}
    />

    <EnrichmentStatsComponent
      stats={stats}
      requestStatus={statsRequestStatus}
    /> */}

    <EnrichmentToolbar
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      statusFilter={statusFilter}
      typeFilter={typeFilter}
      onStatusFilterChange={onStatusFilterChange}
      onTypeFilterChange={onTypeFilterChange}
      onClearAllFilters={onClearAllFilters}
      onNewEnrichment={onNewEnrichment}
    />

    <EnrichmentTable
      jobs={jobs}
      requestStatus={jobsRequestStatus}
      hasActiveFilters={hasActiveFilters}
      page={page}
      pageSize={pageSize}
      totalJobs={totalJobs}
      sort={
        sortBy && sortOrder ? { sortBy, order: sortOrder } : null
      }
      onSort={onSortChange}
      onPaginationChange={onPaginationChange}
      onAddToProspects={onAddToProspects}
      onAddToSequence={onAddToSequence}
      onExport={onExport}
      onFailedReport={onFailedReport}
      onDelete={onDelete}
      onCancel={onCancel}
      onNewEnrichment={onNewEnrichment}
      onRetry={onRetry}
      onViewJob={onViewJob}
    />
  </div>
  );
};

export default CsvEnrichment;
